(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-carousel"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  const filterButtons = document.querySelectorAll('.filter-button');
  const items = document.querySelectorAll('.carousel-item');
  const emptyMsg = document.querySelector('.empty-state-message');

  function filterAndUpdate() {
    const selected = Array.from(filterButtons)
      .filter(btn => btn.classList.contains('selected'))
      .map(btn => btn.dataset.style);

    let visibleCount = 0;

    items.forEach(item => {
      const tags = item.dataset.tags.split(',');
      const show = selected.length === 0 || selected.some(s => tags.includes('TRAY_' + s));
      item.classList.toggle('hidden', !show);
      if (show) visibleCount++;
    });

    emptyMsg.style.display = visibleCount === 0 ? 'block' : 'none';

    mobileCarousel.init();
    desktopCarousel.init();
  }

  filterButtons.forEach(btn => {
    btn.addEventListener('click', () => {
      btn.classList.toggle('selected');
      btn.setAttribute('aria-pressed', btn.classList.contains('selected'));
      filterAndUpdate();
    });
  });

  function Carousel(trackId, prevCls, nextCls, statusId, perPage) {
    this.track = document.getElementById(trackId);
    this.items = Array.from(this.track.querySelectorAll('.carousel-item:not(.hidden)'));
    this.prev = document.querySelector('.' + prevCls);
    this.next = document.querySelector('.' + nextCls);
    this.status = document.getElementById(statusId);
    this.perPage = perPage;
    this.pages = Math.ceil(this.items.length / perPage);
    this.current = 0;

    this.updateStatus = () => this.status.textContent = `${this.current + 1} of ${this.pages}`;
    this.scrollTo = page => {
      if (page < 0 || page >= this.pages) return;
      const idx = page * perPage;
      const el = this.items[idx];
      const offset = el.offsetLeft - (this.track.clientWidth - (el.offsetWidth * perPage + 10 * (perPage -1))) / 2;
      this.track.scrollTo({ left: offset, behavior: 'smooth' });
      this.current = page;
      this.updateStatus();
    };

    this.prev.addEventListener('click', () => this.scrollTo(this.current - 1));
    this.next.addEventListener('click', () => this.scrollTo(this.current + 1));
    this.track.addEventListener('scroll', () => {
      const center = this.track.scrollLeft + this.track.clientWidth /2;
      const idx = this.items.findIndex(el => el.offsetLeft + el.offsetWidth/2 >= center);
      if (idx !== -1) {
        const pg = Math.floor(idx / this.perPage);
        if (pg !== this.current) { this.current = pg; this.updateStatus(); }
      }
    });
    this.init = () => {
      this.items = Array.from(this.track.querySelectorAll('.carousel-item:not(.hidden)'));
      this.pages = Math.ceil(this.items.length / this.perPage);
      this.current = 0;
      this.updateStatus();
      this.scrollTo(0);
    };
    this.init();
  }

  const mobileCarousel = new Carousel('carouselTrackMobile','prev-mobile','next-mobile','carousel-status-mobile',1);
  const desktopCarousel = new Carousel('carouselTrackDesktop','prev-desktop','next-desktop','carousel-status-desktop',3);
});

  } catch(e) { console.error(e); }
})();
})();
